import nceCourses from '../../assets/files/ncecourses.pdf'


export const collegesData = [
    {
    categoryTitle: 'COLLEGES OF EDUCATION',
    contentSection: [
        {
            id: 0,
            contentSectionName: 'List of Courses (COLLEGES OF EDUCATION)',
            contentPdf: ``,
            contentFile: nceCourses,
        },
        {
            id: 1,
            contentSectionName: 'List of Schools',
            pageTile: `COLLEGES OF EDUCATION`,
            desc: [
                `Listed in this Chapter are the Polytechnics and Monotechnics in Nigeria and obtainable Programmes. Candidates are strongly advised to carefully study the 
                requirements set out in this Chapter of this Brochure before selecting any of the Programmes.`,
                `Listed below are the names of Polytechnics in Nigeria. The abbreviations indicated against them are the ones used in this Brochure.`
            ],
            sections: [
                {
                    id: 1,
                    sectionTitle: `A. FEDERAL COLLEGES OF EDUCATION (REGULAR)`,
                    contents: [
                        {
                            abbreviation: `ADEYEMI`,
                            instName: `Adevemi College of Education`,
                            instAddress: `P.M.B. 520 Ondo, Ondo State.`,
                            instPhone: [`035-610050,`,`610121`,`610151`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ALVAN`,
                            instName: `Alan Ikoku Federal College of Education`,
                            instAddress: `Owerri • M B 1033 Owerri mo State`,
                            instPhone: [`083230300`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-ABEO`,
                            instName: `Federal College of Education,`,
                            instAddress: `P.M.B. 2096, Osiele, Abeokuta, Ogun State.`,
                            instPhone: [``],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-AMUFU`,
                            instName: `Federal College of Education. Eha-Amufu.`,
                            instAddress: `P.M.B. 2001, Eha-Amufu, Enugu State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-JAMA'ARE`,
                            instName: `Federal College of Education. Jama'are.`,
                            instAddress: `Bauchi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-BENUE`,
                            instName: `Federa College of Education Odugbo,`,
                            instAddress: `Odugbo, Apa, Benue State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-EBONVI`,
                            instName: `Federal College of Education. Isu.`,
                            instAddress: `Onicha Ebonvi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-EDO`,
                            instName: `Federal Collece of Education (Technical chiadolor.`,
                            instAddress: `Ovia North. Edo State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-KANO`,
                            instName: `Federal College of Education Kano`,
                            instAddress: `P M B 3045 Kano. Kano State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FC-KAT`,
                            instName: `Federal College of Education. Katsina`,
                            instAddress: `P.M.B. 2041, Katsina, Katsina State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-KONTAGORA`,
                            instName: `Federal College of Education. Kontagora`,
                            instAddress: `Kontagora`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-OBUDU`,
                            instName: `Federal College of Education, Obudu,`,
                            instAddress: `P.M.B. 1038, Obudu, Cross river state`,
                            instPhone: [`045-550513.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-OKENE`,
                            instName: `Federal College of Education. Okene.`,
                            instAddress: `P.M.B. 1026. Okene, Kogi State.`,
                            instPhone: [`058-500555.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-IWO`,
                            instName: `Federal College of Education, Iwo,`,
                            instAddress: `Iwo, Osun State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-PANKSHIN`,
                            instName: `Federal College of Education, Pankshin,`,
                            instAddress: `P. O. Box. 27. Pankshin. Plateau State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-SOKOTO`,
                            instName: `Federal College of Education, Gidan Madi`,
                            instAddress: `Tangaza. Sokoto State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-YOLA`,
                            instName: `Federal College of Education. Yola.`,
                            instAddress: `P.M.B. 2042 Yola Adamawa State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FCE-ZARIA`,
                            instName: `Federal College of Education, Zaria,`,
                            instAddress: `P.M.B. 1041, Zaria Kaduna State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `NASE`,
                            instName: `Nigerian Army School of Education.`,
                            instAddress: `P.M.B. 1410, Ilorin, Kwara State.`,
                            instPhone: [``,],
                            email: [`banase army@vaboo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `NINL`,
                            instName: `National Institute for Nigerian languages Aba`,
                            instAddress: `abia state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                    ]
                },
                {
                    id: 2,
                    sectionTitle: `B. FEDERAL COLLEGES OF EDUCATION (TECHNICAL)`,
                    contents: [
                        {
                            abbreviation: `FT-AKOKA`,
                            instName: `Federal College of Education (Technical), Akoka,`,
                            instAddress: `P.O. Box 269. Yaba. Lagos State.`,
                            instPhone: [`08033208653`,],
                            email: [`Fcetakoka@yanoo.com`,],
                            website: [`www.tcetakoka.org`,]
                        },
                        {
                            abbreviation: `FT-ASABA`,
                            instName: `Federal College of Education (Technical), Asaba,`,
                            instAddress: `P.M.B. 1044, Asaba, Delta State.`,
                            instPhone: [`046-280331,`, `08033208653`],
                            email: [`fcetakoka@yahoo.com`,],
                            website: [`www.fcetakoka.org`,]
                        },
                        {
                            abbreviation: `FT-BICHI`,
                            instName: `Federal College of Education (Technical), Bichi,`,
                            instAddress: `P.M.B. 3473, Bichi, Kano State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FT-GOMBE`,
                            instName: `Federal College Education (Technical), Gombe,`,
                            instAddress: `P.M.B. 60, Gombe, Gombe State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FT-GUSAU`,
                            instName: `Federal College of Education (Technical) (Female Only), Gusau`,
                            instAddress: `Gusau, Zamfara State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FT-OMOKU`,
                            instName: `Federal College of Education (Technical), Omoku,`,
                            instAddress: `P.M.B. 11, Omoku, Rivers State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FT-POTIS`,
                            instName: `Federal College Education (Technical), Potiskum,`,
                            instAddress: `Potiskum, Yobe State.`,
                            instPhone: [`076-420716-8.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FT-UMUNZE`,
                            instName: `Federal College of Education Technical Umunze,`,
                            instAddress: `P.M.B. 0189, Umunze, Anambra State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                    ]
                },
                {
                    id: 3,
                    sectionTitle: `C. FEDERAL COLLEGES OF EDUCATION (SPECIAL)`,
                    contents: [
                        {
                            abbreviation: `FCS-OYO`,
                            instName: `Federal College of Education (Special), Oyo,`,
                            instAddress: `P.M.B. 1089, Oyo, Oyo State.`,
                            instPhone: [`038-23017.`,],
                            email: [``,],
                            website: [``,]
                        },
                    ]
                },
                {
                    id: 4,
                    sectionTitle: `D. STATE COLLEGES OF EDUCATION`,
                    contents: [
                        {
                            abbreviation: `AGBOR`,
                            instName: `College of Education, Agbor,`,
                            instAddress: `P.M.B. 2090,Agbor, Delta state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AK-COE`,
                            instName: `Aminu Kano College of Education. капо,`,
                            instAddress: `капо, Kano State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AKSCOE`,
                            instName: `Akwa-Ibom State College of Education, Afaha-Nsit,`,
                            instAddress: `P.M.B. 1019, Etinan, Akwa-bom State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AKWANGA`,
                            instName: `College of Education, Akwanga,`,
                            instAddress: `P.M.B.05, Akwanga Nassarawa state.`,
                            instPhone: [`047-52171.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `АКАMКРА`,
                            instName: `Cross River State College of Education, Akamkpa,`,
                            instAddress: `P.M.B. 1171, Calabar, Cross River State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ANKPA`,
                            instName: `College of Education, Ankpa,`,
                            instAddress: `P.M.B.1033, Ankpa, Kogi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ARGUNGU`,
                            instName: `Adamu Augie College of Education, Argungu`,
                            instAddress: `Argungu Kebbi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AROCHUKWU`,
                            instName: `Abia State College of Education Technical) Arochukwu,`,
                            instAddress: `Arochukwu, Abia state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ASCOEA`,
                            instName: `Aminu Saleh College of Education, Azare,`,
                            instAddress: `P.M.B. 44. Azare Bauchi State`,
                            instPhone: [`071-20150`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ATB-COE`,
                            instName: `Adamu Tafawa Balewa College of Education, Kangere.`,
                            instAddress: `Kangere, Bauchi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `BAMA`,
                            instName: `Umar-Ibn EI-Kanemi College of Education, Science and lechnology, Bama,`,
                            instAddress: `Bama, Borno State`,
                            instPhone: [`08038664467`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `BOCOE`,
                            instName: `Bilyaminu Othman College of Education,`,
                            instAddress: `P.M.B. 001, Dass, Bauchi State.`,
                            instPhone: [`07034573403`, `08022126314`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `BOGORO-COE`,
                            instName: `Bogoro college of Education, Bogoro,`,
                            instAddress: `Bogoro, Bauchi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CLIS-NGURU`,
                            instName: `Atiku Abubakar College of Legal and Islamic Studies, Nguru,`,
                            instAddress: `Neuru, Yobe State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-BILLIRI`,
                            instName: `College of Education,`,
                            instAddress: `P.M.B. 011, Billiri, Gombe State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-BUKURU`,
                            instName: `college of Education, Bukuru,`,
                            instAddress: `Bukuru, Plateau State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-DARAZO`,
                            instName: `College of Education, Darazo,`,
                            instAddress: `Darazo, Bauchi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-EDO`,
                            instName: `Edo State College of Education,`,
                            instAddress: `Edo State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-NAFADA`,
                            instName: `Gombe State College o Education and Legal Studies, Nafada,`,
                            instAddress: `P.M.B. 0191, Gombe, Gombe State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `IMSCOL`,
                            instName: `Imo State College of Education.`,
                            instAddress: `Thitte/Uboma, Imo State,`,
                            instPhone: [`07085021629,`, `08137997283,`, `07057267639`],
                            email: [`imscedu@gmail.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `IIBCOE`,
                            instName: `Isaac Jasper Boro College o Education,`,
                            instAddress: `Sagbama, P. M. B. 74, Bayelsa State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `DUTSINMA`,
                            instName: `Isa Kaita College of Education,`,
                            instAddress: `P.M.B. 5007, Dutsinma, Katsina State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `EACOE`,
                            instName: `Emmanuel Alavande College of Education,`,
                            instAddress: `P.M.B. 1010, Oyo, Oyo State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [`www.eacoed.com,`, `www.eacoed.edu.ng`]
                        },
                        {
                            abbreviation: `ESCE(T)`,
                            instName: `Enugu State College of Education (Tech.) Enugu`,
                            instAddress: `Abakaliki Rd. P.M.B. 01793, Enugu, Enugu state.`,
                            instPhone: [`042-313557`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `EKIADOLOR`,
                            instName: `College of Education, Ekiadolor,`,
                            instAddress: `P.M.B. 1144, Benin City, Edo State.`,
                            instPhone: [`052-440002.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GASHUA`,
                            instName: `Umar Suleiman College of Education,`,
                            instAddress: `P.M.B. 02 Gashua, Yobe State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GINDIRI`,
                            instName: `college of caucation, Gindiri`,
                            instAddress: `Gindiri Plateau State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GUMEL`,
                            instName: `Jigawa State College of Education, Gumel,`,
                            instAddress: `P.M.B. 1002, Jigawa State.`,
                            instPhone: [`064-650227`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MOCPED`,
                            instName: `Michael Otedola College o Primary Education Noforiji,`,
                            instAddress: `KM 7, Epe - Ijebu-Ode Road, P.M.B. 1028, Epe, Lagos State.`,
                            instPhone: [``,],
                            email: [`info@mocped.edu.ng`,],
                            website: [`mocped.edu.ng`,]
                        },
                        {
                            abbreviation: `MOSOGAR`,
                            instName: `Delta State College o Physical Education, Mosogar`,
                            instAddress: `Mosogar Delta state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-HONG`,
                            instName: `College of Education, Hong,`,
                            instAddress: `P.M.B. 2237, Adamawa state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JJANIKIN`,
                            instName: `Adeniran Ogunsanya College of Education.`,
                            instAddress: `Otto/Ijanikin Lagos State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `IGUEBEN`,
                            instName: `College of Education`,
                            instAddress: `P.M.B. 003, Igueben Edo State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `IJEBU-ODE`,
                            instName: `Tai Solarin College of Education, Ijebu-Ode`,
                            instAddress: `P.M.B. 2128, ljebu-Ode, Ogun State.`,
                            instPhone: [`037-431996.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `IKWO`,
                            instName: `Ebonyi State College of Education, Ikwo`,
                            instAddress: `P.M.B.2, Ikwo, Ebonyi State.`,
                            instPhone: [`030610152.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-IKERE`,
                            instName: `College of Education, Ikere`,
                            instAddress: `P.M.B. 250, Ikere Ekiti State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ILA`,
                            instName: `Osun State College of Education, Ila-Orangun`,
                            instAddress: `P.M.B. 207, Ila-Orangun, Osun state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-ILESHA`,
                            instName: `College of Education, llesha,`,
                            instAddress: `P.M.B. 1527, llesha, Osun State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ILORIN_COL`,
                            instName: `Kwara State College of Education, Ilorin`,
                            instAddress: `P.M.B. 1527, Ilorin, Kwara State.`,
                            instPhone: [`031-220051.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-RINGIM`,
                            instName: `Jigawa State College of Education And Legal Studies,`,
                            instAddress: `P.O. Box 02, Ringim Jigawa state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIGPOLY-COE`,
                            instName: `Jigawa State Polytechnic (NCE),`,
                            instAddress: `Dutse Jigawa State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-ZING`,
                            instName: `College of Education, Zing`,
                            instAddress: `P.M.B. 1021, Zing, Taraba State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GIDAN-WAYA`,
                            instName: `Kaduna State College of Education, Gidan-Waya,`,
                            instAddress: `P.M.B. 1024, Kafanchan, Kaduna State`,
                            instPhone: [`061-20229`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KANO`,
                            instName: `Saadatu Rimi College of Education, Kumbotso`,
                            instAddress: `Zaria Rd. P.M.B. 3218 Kano, Kano State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KASCEPS`,
                            instName: `Kano State College o Education and Preliminary Studies, Kano,`,
                            instAddress: `Kano State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KAT-ALA`,
                            instName: `college of Education, Katsina-Ala,`,
                            instAddress: `Benue State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KGCOET`,
                            instName: `Kogi State College of Education (Technical).`,
                            instAddress: `P.M.B. 242, Kabba, Kogi State.`,
                            instPhone: [`08164510078,`, `08153685397,`, `08035048648`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `LAFIAGI (T)`,
                            instName: `College of Education, (Tech), Lafiagi,`,
                            instAddress: `P.M.B. 1, Lafiagi. Kwara State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `LANLATECOE`,
                            instName: `College of Education, Lanlate. OYo State.`,
                            instAddress: `OYo State. P.M.B. 001`,
                            instPhone: [``,],
                            email: [`olusegunadeagbo63@gmail.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MAIDU`,
                            instName: `Kashim-Ibrahim College o Education, Maiduguri,`,
                            instAddress: `P.M.B. 1469, Maiduguri, Borno State.`,
                            instPhone: [`076-232086.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-MINNA`,
                            instName: `College of Education, Minna,`,
                            instAddress: `P.M.B. 39, Minna, Niger State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MOGOCLIS`,
                            instName: `Mohammed Goni college of Legal and Islamic studies`,
                            instAddress: `P.M.B. 1526, Maiduguri, Borno State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MOJE-COE`,
                            instName: `Moie College of Education, Erin-lle,`,
                            instAddress: `Kwara State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `NOCOEN`,
                            instName: `Nwafor Orizu College of Education, Nsugbe`,
                            instAddress: `P.M.B. 1734, Onitsha, Anambra State.`,
                            instPhone: [`090500821.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-MARU`,
                            instName: `College of Education, Maru,`,
                            instAddress: `Maru, Zamfara state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-OJU`,
                            instName: `College of Education, Oju,`,
                            instAddress: `P.M.B. 2035, Otukpo, Benue State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-ORO`,
                            instName: `College of Education, Oro,`,
                            instAddress: `P.M.B. 309. Oro. Kwara State`,
                            instPhone: [``,],
                            email: [`info@kwcoed.edu.ng,`, `inquiry@kwcoed.edu.ng`],
                            website: [`www.kwcoedoro.edu.ng`,]
                        },
                        {
                            abbreviation: `SOKOTO`,
                            instName: `Shehu Shagari College of Education, Sokoto,`,
                            instAddress: `P. M.B. 2129, Sokoto State.`,
                            instPhone: [`060-232190.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ULI-COE`,
                            instName: `ULI College of Education,`,
                            instAddress: `Uli, Anambra State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-BIU`,
                            instName: `College of Education, Waka-Biu`,
                            instAddress: `P.M.B. 1502, Waka-Biu, Borno State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-WARRI`,
                            instName: `College of Education, Warri,`,
                            instAddress: `P.M.B. 1251, Warri, Delta State.`,
                            instPhone: [`053-230036.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-ZUBA`,
                            instName: `FCT College of Education, Zuba,`,
                            instAddress: `Zuba, FCT-Abuja.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        }
                    ]
                },
                {
                    id: 5,
                    sectionTitle: `E. PRIVATE COLLEGES OF EDUCATION`,
                    contents: [
                        {
                            abbreviation: `ACOE`,
                            instName: `Alhikma College of Education, Ankpa,`,
                            instAddress: `Ankpa, Kogi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ADESHINA`,
                            instName: `Adeshina College of Education,`,
                            instAddress: `Share, Ifelodun L.G.A. KWARA STATe`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AGZ-BAJOGA`,
                            instName: `AGZ College of Education, Bajoga,`,
                            instAddress: `Gombe State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AHLUS-COE`,
                            instName: `Ahlus-Suffah College of Education,`,
                            instAddress: `Kaduna. Kaduna state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AICOEP`,
                            instName: `Arabic and Islamic College of Education,`,
                            instAddress: `P. O. Box 127, Potiskum. Yobe state`,
                            instPhone: [`08068962851,`, `07068962792`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AJETUNMOBI-COE`,
                            instName: `Ajetunmobi College of Education,`,
                            instAddress: `Ira, Kwara State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AL-UMMAH-COE`,
                            instName: `Al-Ummah College of Education,`,
                            instAddress: `Iwo, Osun state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AL-MADINAH`,
                            instName: `Al-Madinah College of Education,`,
                            instAddress: `Osogbo, Osun State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AMCOE-COE`,
                            instName: `Abdullahi Maikano College of Education,`,
                            instAddress: `Wase. Plateau State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-ERO`,
                            instName: `College of Education, Ero-Akure,`,
                            instAddress: `km 10, Akure-Express Way, P.O. Box 31, Akure ondo state.`,
                            instPhone: [`08033025906,`, `08033946501`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AKLEGAL`,
                            instName: `Aminu Kano College o Islamic and Legal Studies,`,
                            instAddress: `kano, Kano state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AL-IBADAN`,
                            instName: `Al-Ibadan College of Education, Ibadan,`,
                            instAddress: `Ibadan, oyo state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AMEENUDEEN`,
                            instName: `Ameenudeen College of Education,`,
                            instAddress: `483, Suleiman Crescent, Kano, Kano.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ANGEL`,
                            instName: `Angel Crown College of Education,`,
                            instAddress: `KM 11, Karshi Road, Gidan-Daya, FCT-Abuja.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ANISE`,
                            instName: `Annur Institute for Islamic Education,`,
                            instAddress: `Kwajalawa, Rangaza Off Yadakunya Road, Ungogo L.G., P.O. Box 3708, Kano, kano state`,
                            instPhone: [`08035869312`, `08034335514`, `08028404902`, `80052 78469` ],
                            email: [`annurintitute@yahoo.com;`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ANSAR`,
                            instName: `Ansar-Ud-Deen college or cducation.`,
                            instAddress: `6. Karimu Street. solo. P.O .Box 24, Oshodi, Lagos State.`,
                            instPhone: [`520027`, `7923104`, `08033733923`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ASCAS`,
                            instName: `Ameer Shehu Idris College of Advance Studies,`,
                            instAddress: `shafiu Abdulani Road, Gaskiya, Laria, Kaduna State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ASSCOED`,
                            instName: `Assanusiyah College of Education,`,
                            instAddress: `P.M.B 2000 Ipetumodu Rd. Oke Yidi, Odeomu, Osun State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `APA`,
                            instName: `Apa college ot Education,`,
                            instAddress: `Aidojodo-Okpoga, Benue State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ATCOI`,
                            instName: `African Thinkers Community of inquiry College of Education, Enugu`,
                            instAddress: `1. Coa Citv Universitv Road. Independent lavout P.M.B. 15510, Enugu, Enugu State.`,
                            instPhone: [`042-457820`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AWORI`,
                            instName: `Awori District College of Education,`,
                            instAddress: `Bankole Estate, Ajibode Road Ijako-Ota, Ogun State.`,
                            instPhone: [`08057338313,`, `08023937892`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KE-COE`,
                            instName: `Kogi East College of Education,`,
                            instAddress: `Kogi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `BELCOED`,
                            instName: `Best Legacy college of cducation.`,
                            instAddress: `kirun Rd. Oke-Owode, Ogbomoso, P.O.Box 1744, Oyo State.`,
                            instPhone: [`08039181475,`, `07035050787`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `BETHEL`,
                            instName: `Bethel College of Education,`,
                            instAddress: `ijare, Ondo State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `BIAIS`,
                            instName: `Bauchi institute for Arabic and islamic studies`,
                            instAddress: `c/o Bakari Dukku Primary School Bauchi P.O. Box 2031. Bauchi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `BIGA-COED`,
                            instName: `Biga College of Education,`,
                            instAddress: `Arkilla, Federal Low Cost, Nasarawa Sokoto State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CALVIN`,
                            instName: `Calvin roundation College of caucation.`,
                            instAddress: `Naka, Benue State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COEN`,
                            instName: `The College of Education, Nsukka,`,
                            instAddress: `P.M.B 2003, Nsukka, Enugu State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-OFFA`,
                            instName: `College of Education,`,
                            instAddress: `Irra Rd. llemona, P.M.B. 4415, Offa, Kwara State.`,
                            instPhone: [`08060281768,`, `08056357566,`, `080521444902,`, `08051687650.`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-KURA`,
                            instName: `College of Education,`,
                            instAddress: `Kura Kano State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CORNER`,
                            instName: `Cornerstone College of Education,`,
                            instAddress: `Odegbami Street. Off Adeniyi James Avenue, Ikeja P.O. Box 50, UNILAG Post office, Lagos State`,
                            instPhone: [`01-7748919`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CORONA`,
                            instName: `Corona College of Education,`,
                            instAddress: `25, Association Avenue lupeju, Lagos State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CCONOH-COE`,
                            instName: `Christian Chukwuma Onoh, College of Education,`,
                            instAddress: `Enugu. Enugu State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COVENANT-COE`,
                            instName: `Covenant college of Education, Aba,`,
                            instAddress: `Aba, Abia State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CHRIST-COE`,
                            instName: `Christian College of Education,`,
                            instAddress: `Gombe Gombe State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CITY`,
                            instName: `City College of Education,`,
                            instAddress: `SanI Abacha Rd. Maraba Gurku. P.O. Box 3094, Garki, Abuja.`,
                            instPhone: [`09-6700452,`, `90-602944`, `08035955966`, `08036339897`, `08035487209`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CLIMAX`,
                            instName: `Climax College of Education,`,
                            instAddress: `Bauchi. Bauchi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `COE-DUT`,
                            instName: `College of Education`,
                            instAddress: `Dutsen-Tanshi, Bauchi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `CRESTFIELD`,
                            instName: `Crestfield College of Education,`,
                            instAddress: `Erin Osun, Osun State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `DA'AWA-COE`,
                            instName: `Da awa college of Education,`,
                            instAddress: `Bauchi, Bauchi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `DANYAYA`,
                            instName: `Danyaya College of Education,`,
                            instAddress: `Ningi, Bauchi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `DELAR`,
                            instName: `Delar College of Education,`,
                            instAddress: `Housing Corporation Office, Egbeda P.O. Box 6379, Agodi-Gate,`,
                            instPhone: [`08033549165.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `DIAMOND`,
                            instName: `Diamond College of Education`,
                            instAddress: `Aba Abia state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `DOVIANA-COE`,
                            instName: `Doviana college of Education,`,
                            instAddress: `Gboko, Benue state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `EBENEZER`,
                            instName: `Ebenezer College of Education`,
                            instAddress: `Edda Ebonyi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `EBIJE-COE`,
                            instName: `Emmanuel Ebiie Ikwue College of Education,`,
                            instAddress: `KM 2, Otukpo -Enugu Road, P.M.B. 2040, Otukpo, Benue State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ECWA-COE`,
                            instName: `ECWA College of Education,`,
                            instAddress: `Igbaja, Kwara State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ECWA-JOS`,
                            instName: `ECWA College of Education,`,
                            instAddress: `P O Box 5298 JOS, Plateau State`,
                            instPhone: [`08061533023`,],
                            email: [`letseminarv@vaboocom`,],
                            website: [`www.jetsnigeria.org`,]
                        },
                        {
                            abbreviation: `ELDER -OYAMA`,
                            instName: `Elder Oyama Memorial College of Education,`,
                            instAddress: `Ofat, Obubra, Cross River State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ELI-COE`,
                            instName: `Elizabeth Memorial College of Education,`,
                            instAddress: `Odenigbo, Nsukka, Enugu State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ELIBEST`,
                            instName: `Elibest College of Education,`,
                            instAddress: `Ilu-Abo, Owo Akure, Ondo State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `EMAMOR`,
                            instName: `Emamor College of Education.`,
                            instAddress: `Abua. Rivers State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `FESTMED`,
                            instName: `Festmed College of Education.`,
                            instAddress: `P.O. Box 7, Ajowa-Ikare Highway, Ajowa Akoko Ondo State`,
                            instPhone: [`08023208449`,],
                            email: [`femihallmark@gmail.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GARKUWA`,
                            instName: `Adamu Garkuwa College of Education.`,
                            instAddress: `Toro, Bauchi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GOE-JOS`,
                            instName: `Global College of Education,`,
                            instAddress: `c/o COCIN Primary/Sceondary School, Dadin Kowa. P.O. Box 1215, Jos. Plateau State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GBOKO-COE`,
                            instName: `Gboko College of Education,`,
                            instAddress: `Кт 4 Allade Road P.M.B. 024 Gboko, Benne State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GPI-COE`,
                            instName: `God's Power International College of Education,`,
                            instAddress: `Anyigba, Kogi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GRAND-PLUS`,
                            instName: `Grand-Plus College of Education,`,
                            instAddress: `lorin. Kwara State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GS-COE`,
                            instName: `Good Shepherd College of Education.`,
                            instAddress: `Danlemo Alakuko Ogun State,`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `GRACE-COE`,
                            instName: `Grace College of Education,`,
                            instAddress: `Oshogbo, Osun State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `HAMZAINAB`,
                            instName: `Hamzainab College of Education.`,
                            instAddress: `Osogbo, Osun State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `HAMZAT-COE`,
                            instName: `Imam Hamzat College of Education`,
                            instAddress: `Ilorin Kwara State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `HAVARD`,
                            instName: `Havard Wilson College of Education,`,
                            instAddress: `40-50, Umuimo Road (by 146 Aba-Owerri Road Abavi, P.O.Box 5216, Abavi, Aba, Abia State`,
                            instPhone: [`07035209118`, `08037262842`],
                            email: [`provost@havardwilsoncollege.com`,],
                            website: [`havardwilsoncollege.com`,]
                        },
                        {
                            abbreviation: `HIS-GRACE`,
                            instName: `HIS Grace Independent college ot Education,`,
                            instAddress: `ilorin, Kwara State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `HILL-COE`,
                            instName: `Hill College of Education, Gwanje, Akwanga,`,
                            instAddress: `P.O.Box 06, Akwanga, Nasarawa State.`,
                            instPhone: [`08035937420.`,],
                            email: [`hilcoea@yahoo.com`,],
                            website: [`www.hillcoeg.edu.ng`,]
                        },
                        {
                            abbreviation: `HOPE-COE`,
                            instName: `Hope and Anchor College of Education,`,
                            instAddress: `Suleja, Niger State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ICE-KARU`,
                            instName: `Innovative College of Education,`,
                            instAddress: `Karu, Nasarawa state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `IECE`,
                            instName: `Institute of Ecumenical Education,`,
                            instAddress: `Thinker Corner, Enugu, Enugu State.`,
                            instPhone: [`08033401019.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ILCOED`,
                            instName: `Ilori College of Education, Ede, Osun State.`,
                            instAddress: `Ogberin Hill, Loogun Road, P.M.B. 218 Ede, Osun State`,
                            instPhone: [`08033899362`,],
                            email: [`iloricollegeofedu1@gmail.com`,],
                            website: [`www.iloricollege.edu.ng`,]
                        },
                        {
                            abbreviation: `IMAM-SAIDU`,
                            instName: `Imam saidu college of Education,`,
                            instAddress: `P.O.BOX 407, Funtua, Katsina State`,
                            instPhone: [`08065981890,`, `08060766263`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `IPERE_COE`,
                            instName: `Ipere college o Education,`,
                            instAddress: `Agyaragu, Obi LGA, P.M.B. 149, Lafia, Nasarawa state.`,
                            instPhone: [`08029770905`, `07059436317`, `08032274565`, `08085493810`],
                            email: [`ipere.college@yahoo.com`, `Usmanstephen.ndo@gmail.com`],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIBWIS`,
                            instName: `JIbwIs college ot Education,`,
                            instAddress: `Gombe. Gombe State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIBWIS-BAU`,
                            instName: `Jibwis College of Education,`,
                            instAddress: `Jama'are, Bauchi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIBWIS-GUMAU`,
                            instName: `JIBWIS College of Education,`,
                            instAddress: `Gumau, Bauchi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIBWIS-KEF`,
                            instName: `JIBWIS College of Education,`,
                            instAddress: `Kaibo Fulani, Keffi, Nasarawa State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIBWIS-POT`,
                            instName: `JIBWIS College of Education,`,
                            instAddress: `Potiskum, Yobe State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIBWIS-ZUR`,
                            instName: `JIBWIS College of education,`,
                            instAddress: `Potiskum, Yobe State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `JIBWIS-ZUR`,
                            instName: `JIBWIS College of tducation,`,
                            instAddress: `Zuru, Kebbi State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KINSEY`,
                            instName: `Kinsey college ot Education, lorin,`,
                            instAddress: `11, Olorunsogo Street, Off Fate, Behind Federal Secretariat, Fate-G.R.A. P.O. Box 589 lorin Kwara State`,
                            instPhone: [`031-226925,`, `08033842827`, `08035837765`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KWARARAFACOE`,
                            instName: `Kwararafa College of Education,`,
                            instAddress: `Otukpo, Benue State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KZ-COE`,
                            instName: `Kazaure College of Education.`,
                            instAddress: `Kazaure, Jigawa state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `LESSEL`,
                            instName: `Lessel College of Education,`,
                            instAddress: `P.M.B. 02, Lessel, Ushongo LGA, Renue State`,
                            instPhone: [``,],
                            email: [`lesselcoe@yahoo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `LINKS-MORO`,
                            instName: `College of Education, Foreign Links Campus Moro, Ife, North, Nigeria.`,
                            instAddress: `P.O.Box 1964, Obafemi Awolowo University, Ile-Ife.`,
                            instPhone: [`+2348033705261.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `LIFE-GATE`,
                            instName: `life Gate Collese of Fducation Afon`,
                            instAddress: `Asa LGA, Kwara State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `NAMCOE`,
                            instName: `Nana Aisha Memorial College of Education`,
                            instAddress: `P.O. Box 14730 Alagbado, Ilorin, Kwara State`,
                            instPhone: [`07038688831`, `08058094258`],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `AMCOE-WASE`,
                            instName: `Abdullabi Maikano College of Education`,
                            instAddress: `Wase, Plateau State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MEADOW`,
                            instName: `Meadow Hall College of Education,`,
                            instAddress: `Meadow Hall Way, Alma Beach Estate Lekki-Epe Express Way, Lagos state.`,
                            instPhone: [`07061369812`, `08116814813`],
                            email: [`into@meadowhallgroun.com`,],
                            website: [`www.meadowhalgroun.com`,]
                        },
                        {
                            abbreviation: `METRO-COE`,
                            instName: `Metro College of Education.`,
                            instAddress: `Adogi, Nasarawa State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MCF-COE`,
                            instName: `Michael & Cecilia Foundation College Education`,
                            instAddress: `Agbarha-Otor, Ughelli, Delta State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MUHYIDEEN`,
                            instName: `Muhvideen College of Education.`,
                            instAddress: `ilorin. Kwara State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MULCOED`,
                            instName: `Muftau' Lanihun College of Education`,
                            instAddress: `Ibadan/Lagos Express way, Oremeji P.O.Box 27050, Ibadan.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MURICOED`,
                            instName: `Muritadha College of Education (Institute of Arabic and Islamic Studies)`,
                            instAddress: `Kumapavi Road, Olodo, P.O. Box 3346, Mapo, Ibadan, ovo State.`,
                            instPhone: [`07036798891`, `08055216243`],
                            email: [`murie2@vahoo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `MUS'AB`,
                            instName: `Mus'ab Bn Umair Communitv College of Education,`,
                            instAddress: `Bajoga Gombe State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `NOSAKHARE`,
                            instName: `Nosakhare College of Education`,
                            instAddress: `150. Upper Mission Road. Benin City, Edo State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `OLEKAMBA`,
                            instName: `Olekamba College of Education,`,
                            instAddress: `Afin-Akure, Ondo State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `OMAGA`,
                            instName: `Omaga Ejigbo College of Education,`,
                            instAddress: `Dekina KogI State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ONITCOE`,
                            instName: `ONIT College of Education`,
                            instAddress: `P.O. Box 677, Abagana, Njikoka LGA, Anambra State`,
                            instPhone: [`08037578863`,],
                            email: [`onitcollege@yahoo.com`,],
                            website: [`www.onitcollege.edu.ng`,]
                        },
                        {
                            abbreviation: `OSISATEC`,
                            instName: `Our Saviour Inst. Of Sci. & Tech. College of Education,`,
                            instAddress: `Ogui Rd. Enugu, Enugu State.`,
                            instPhone: [`08037578863.`,],
                            email: [`onitcollege@yahoo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `OSWALD`,
                            instName: `Oswald Waller College of Education,`,
                            instAddress: `Shendam. Plateau State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `PAN-AFR COE`,
                            instName: `PAN African College of Education,`,
                            instAddress: `off ebonna Road, Secretariat/Olorunkuse Way, Offa, kwara state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [`www.panafricoed.edu.ng`,]
                        },
                        {
                            abbreviation: `PEACE-COE`,
                            instName: `Peace College of Education`,
                            instAddress: `Enokpoli, kogi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `PEACELAND`,
                            instName: `Peaceland College of Education`,
                            instAddress: `Enugu, Enugu state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `PEACOCK`,
                            instName: `Peacock College of Education`,
                            instAddress: `Jalingo, Taraba State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `PIAGET`,
                            instName: `Piaget College of Education,`,
                            instAddress: `P.O. Box 193, Quarry Road, Ibara, Abeokuta, Ogun State.`,
                            instPhone: [`0809 772 9196`, `0903 600 2738`],
                            email: [`piagetcoe@gmail.com`,],
                            website: [`www.piagetcoe.edu.ng`, `www.piagetcoe.com`]
                        },
                        {
                            abbreviation: `PREMIER-COE`,
                            instName: `Premier College o Education`,
                            instAddress: `Awo, Egbedore LGA, Osun State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ROYAL-COE`,
                            instName: `Royal College of Education`,
                            instAddress: `Ifo, Ogun State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ROYAL-CITY`,
                            instName: `Royal City College of Education`,
                            instAddress: `lyesi, Off Idirtoko Road, Iyana lyesi, Otta, Ogun State P.O. Box 14712, Ikeja, Lagos State.`,
                            instPhone: [`08074595125`, `08023332006`, `07065304224`],
                            email: [`christroyal@yahoo.com`, `christroyalfamily@yahoo.com`],
                            website: [``,]
                        },
                        {
                            abbreviation: `RUFAI-COL`,
                            instName: `A.D. Rufa'l College for Legal and Islamic Studies,`,
                            instAddress: `Misau, Bauchi State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `SACAS-COE`,
                            instName: `SACAS College of Education`,
                            instAddress: `Kwali, Abuja.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `SARKIN-YAMMA`,
                            instName: `Sarkin Yamma Community College of Education`,
                            instAddress: `Tilden Fulani, Toro L.G.A., Bauchi state`,
                            instPhone: [``,],
                            email: [`svaccoe@vahoo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `SINAI-COE`,
                            instName: `Sinai College of Education and Entrepreneurial studies,`,
                            instAddress: `Gboko, Benue state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `STEADYFLOW`,
                            instName: `Steady Flow College of Education,`,
                            instAddress: `Solomon Tangban Campus, Akparabaong, Cross River State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `TACCOED`,
                            instName: `The African Church College of Education`,
                            instAddress: `Adewale Adegun Avenue. Karaole Estate, Off Elder J.K. Coker Rd P.M.B. 21112, Agege, Lagos Itako-llaive, Lagos state.`,
                            instPhone: [`08141117393.`,],
                            email: [`taccoeng@yahoo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `SACOED NCE`,
                            instName: `St. Augustine College of Education Project Time),`,
                            instAddress: `2, Moronfolu Street. Akoka, Yaba. Lagos State`,
                            instPhone: [`01-821098.`,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ST.FRANCES`,
                            instName: `St. Frances Assisi College of Education`,
                            instAddress: `Wusasa - Zaria, Kaduna State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `ST. PAUL'S`,
                            instName: `st. Paul's community college of education.`,
                            instAddress: `Nnewi, Anambra state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `SUNNAH-COE`,
                            instName: `Sunnah College of Education,`,
                            instAddress: `Bauchi, bauchi state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `TICOED`,
                            instName: `Tijjani Ibrahim College of Education`,
                            instAddress: `Kano`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `TIJANICOE`,
                            instName: `Bayo Tijani College of Education`,
                            instAddress: `Plot 2-8, Bayo Tijani Street, Off Mosalasi Road, Alayo Bus Stop, Egan City Centre, Egan Igando. P.M.B. 01 Ikotun. Lagos State`,
                            instPhone: [`0803045863`,`08032502680`],
                            email: [`bayotijanicollegeoteducation@yahoo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `TOPMOST`,
                            instName: `Topmost College of Education`,
                            instAddress: `P.M.B. 005 Ipaja. Lagos`,
                            instPhone: [`08037204088`, `08037117723`, `01-8752279`],
                            email: [`topcoed@vahoo.com`,],
                            website: [``,]
                        },
                        {
                            abbreviation: `TCIS`,
                            instName: `Turath college of Islamic studies`,
                            instAddress: `Goron Dutse. Kano state.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `KATAB`,
                            instName: `Umar Bun Khatab College ot Education`,
                            instAddress: `Kaduna state`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `UNITY`,
                            instName: `Unitv College of Education`,
                            instAddress: `Auka-Adoka. P. O. Box 2021, Otukpo, Benue State`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `UPLAND`,
                            instName: `Upland College of Education`,
                            instAddress: `Ifira/Ipesi, Akoko, Ondo State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                        {
                            abbreviation: `YEWA`,
                            instName: `Yewa Central College of Education,`,
                            instAddress: `P MB 2014 Abeokuta KLM 6, Ayetoro Rd. College Bus-Stop, Adehun Abeokuta Ogun state`,
                            instPhone: [`08033841546,`,],
                            email: [`provost@yewacentralcollege-ng.com`,],
                            website: [`www.vewacentralcollege-ng.com`,]
                        },
                        {
                            abbreviation: `YBUCLGS`,
                            instName: `Yusuf Bala Usman College of Legal and General Studies`,
                            instAddress: `Daura, P.M.B. 2201, katsina, Katsina State.`,
                            instPhone: [``,],
                            email: [``,],
                            website: [``,]
                        },
                    ]
                },

            ]
        },
    ]
 }
]